import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { ConsultarInterfazComponent } from './ConsultarInterfaz.component';

import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';


const routes = [
{
    path     : 'ConsultarInterfaz',
    component: ConsultarInterfazComponent,
    canActivate: [RoleGuard], 
    data: { 
        formulario: 'ConsultarInterfaz',
        nombreFormulario : 'Generar Interfaz'
    } 
}
];

@NgModule({
    declarations: [
        ConsultarInterfazComponent
    ],
    imports     : [
    SharedModule,
    RouterModule.forChild(routes)
    ],
    exports     : [
        ConsultarInterfazComponent
    ],
    bootstrap: [ConsultarInterfazComponent],
})

export class ConsultarInterfazModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ConsultarInterfaz/ConsultarInterfaz.module.ts